import React from 'react';

export const Question: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 20 20" fill="currentColor" {...props}>
    <path d="M20 13.536a6.484 6.484 0 00-3.556-5.773 8.817 8.817 0 01-8.682 8.682 6.466 6.466 0 009.062 2.657l3.147.87-.87-3.147A6.441 6.441 0 0020 13.536zm0 0" />
    <path d="M15.271 7.636a7.636 7.636 0 10-14.212 3.881L.028 15.243l3.726-1.031a7.637 7.637 0 0011.517-6.576zM6.464 5.859H5.292a2.343 2.343 0 113.925 1.729l-1 .911v.914H7.05v-1.43l1.376-1.26a1.16 1.16 0 00.381-.865 1.172 1.172 0 00-2.343 0zm.586 4.726h1.171v1.172H7.05zm0 0" />
  </svg>
);
